import FilesList from 'components/CreateEmailModal/components/FilesList/FilesList';

export default FilesList;
